import TimeAgo from "javascript-time-ago"
import en from "javascript-time-ago/locale/en.json"

// Add locale to TimeAgo
TimeAgo.addDefaultLocale(en)

const timeAgo = new TimeAgo("en-US")

/**
 * Formats time in seconds to a human-readable string.
 * @param value The time in seconds to format. You can pass in a formatted string too, and we'll just return it.
 * @param useCompact Whether to use compact notation for large numbers.
 * @returns The formatted time as a string.
 */
export function formatTime(value: number | string | undefined): string {
  if (value === undefined) return "0s"
  if (typeof value === "string") return value

  const seconds = Math.floor(value)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days > 0) {
    return `${days}d ${hours % 24}h`
  } else if (hours > 0) {
    return `${hours}h ${minutes % 60}m`
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`
  } else {
    return `${seconds}s`
  }
}

export function formatTimeAgo(date: Date): string | null {
  if (isNaN(date.getTime())) {
    console.error("Invalid date passed to formatTimeAgo", date)

    return null
  }

  return timeAgo.format(date)
}
